<template>
  <portal>
      <div class="mb-8 d-flex align-center">
          <v-icon color="primary" size="30">mdi-chart-line</v-icon>
          <h1 class="headline ml-4 font-weight-bold grey--text--darken-2 text-uppercase">Performance</h1>
      </div>

      <template v-if="this.user.has_external_household">
          <template v-if="localPerformance == null">
              <p style="text-align: center">The Report is being updated, one moment please.</p>
              <loader/>
          </template>
          <template v-if="localPerformance != null">
              <v-dialog
                  v-if="clientPortalSetting.show_benchmarks && household.can_adjust_portal_benchmarks"
                  overlay-color="white"
                  v-model="dialog"
                  width="800px">
                  <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          color="primary"
                          dark
                          v-bind="attrs"
                          v-on="on"
                          class="mb-2">
                          Adjust Benchmarks
                      </v-btn>
                  </template>
                  <v-card>
                      <v-expansion-panel>
                          <v-expansion-panel-header
                              :hide-actions="true"
                              class="primary title white--text text-h5"
                              color="white">Performance Benchmark Options</v-expansion-panel-header>
                              <report-options
                                  style="padding-left: 10px; padding-right: 10px"
                                  :options="performanceBenchmarkOptions"
                                  @reportOptionUpdated="submitReportOptionUpdate"
                                  @newReport="submitReportUpdate"/>
                      </v-expansion-panel>
                  </v-card>
              </v-dialog>
              <year-to-date-high-charts
                  v-if="localPerformance"
                  :performance="localPerformance"/>
              <year-to-date-table />
          </template>
      </template>
      <template v-else>No data available</template>
      <template v-slot:disclosure>
          <v-col class="px-12 py-8" v-html="company.disclosure_client_portal"></v-col>
      </template>
  </portal>
</template>

<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex';
import Portal from "@/components/Portal";
import YearToDateTable from "@/components/year-to-date/YearToDateTable";
import YearToDateHighCharts from "@/components/year-to-date/YearToDateHighCharts";
import ReportOptions from "@/components/year-to-date/ReportOptions";
import Loader from '@/components/Loader';

export default {
    name: "YearToDatePerformance",
    components: {
        YearToDateTable,
        YearToDateHighCharts,
        Portal,
        ReportOptions,
        Loader
    },
    computed: {
        ...mapGetters('auth', [
            'user',
        ]),
        ...mapGetters('household', [
            'performanceBenchmarkOptions',
        ]),
        ...mapState({
            performance: state => state.household.performance,
            clientPortalSetting: state => state.auth.clientPortalSetting,
            household: state => state.household.household
        }),
        ...mapState('company', [
            'company'
        ])
    },

    data() {
        return {
            dialog: false,
            localPerformance: null
        }
    },

    mounted() {
      if (! this.user.has_external_household) {
            this.$router.push({ name: 'GetStarted' });
            return;
      }

        this.$nextTick(() => {
            this.localPerformance = this.performance;
        })

      window.Echo.channel('client.report.twelveMonthsPerformance.' + this.user.household_id)
          .listen('.Household\\Events\\ClientReportCompleteEvent', (e) => {
              this['PERFORMANCE_SET'](e.performance);
          });

      if (this.performanceBenchmarkOptions == null) {
          this.fetchPerformanceOptions();
      }

    },

    watch: {
      performance() {
          this.localPerformance = this.performance;
      }
    },

    methods: {
        ...mapActions('household', [
            'fetchHousehold',
            'fetchPerformance',
            'fetchPerformanceOptions',
            'updatePerformanceOptions'
        ]),
        ...mapMutations('household', [
            'PERFORMANCE_SET'
        ]),
        submitReportOptionUpdate({payload}) {
           this.updatePerformanceOptions({payload});
        },
        submitReportUpdate() {
            this['PERFORMANCE_SET'](null);
            this.fetchPerformance(true).then(
                () => this.dialog = false
            );
        }
    }
  }
</script>
